import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  AfterViewInit,
  AfterViewChecked,
  importProvidersFrom,
} from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Subject, interval, map } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Meta, Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { GoogleMapsModule } from '@angular/google-maps';
declare var google: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [CommonModule, RouterModule, GoogleMapsModule],
})
export class AppComponent
  implements OnInit, OnDestroy, AfterViewChecked, AfterViewInit
{
  change: boolean = false;
  unsubscribe$ = new Subject();

  constructor(
    private readonly router: Router,
    private readonly toastr: ToastrService,
    private readonly modalService: NgbModal,
    private readonly metaService: Meta,
    private readonly titleService: Title,
    private readonly cdRef: ChangeDetectorRef
  ) {}

  ngOnDestroy(): void {
    window.removeEventListener('online', this.updateOnlineStatus);
    window.removeEventListener('offline', this.updateOnlineStatus);
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }

  ngAfterViewInit(): void {
    this.cdRef.detach();
  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }

  ngOnInit(): void {
    this.addMetaTag();
    const checkInternetSpeed$ = interval(1000).pipe(
      map(() => (navigator as any).connection?.effectiveType)
    );

    checkInternetSpeed$.subscribe((speed) => {
      if (speed == '4g') this.change = false;

      if ((speed == '3g' || speed == '2g') && !this.change) {
        this.change = true;
        this.toastr.info('Your internet speed is slow.');
      }
    });

    window.addEventListener('online', this.updateOnlineStatus);
    window.addEventListener('offline', this.updateOnlineStatus);

    window.addEventListener('popstate', () => {
      if (this.modalService.hasOpenModals()) {
        this.modalService.dismissAll();
      }
    });

    this.router.events.subscribe((x) => {
      if (x instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });
  }

  updateOnlineStatus = () => {
    if (!navigator.onLine) {
      this.toastr.error('Please check your internet.');
    } else {
      this.toastr.success('You are back online.');
    }
  };

  addMetaTag() {
    this.titleService.setTitle('Omni Assist');
    let isProdEnv = environment.production;
    if (!isProdEnv) {
      this.metaService.addTag({ name: 'robots', content: 'noindex, nofollow' });
    }
  }

  ddlType1: any[] = [
    {
      id: '1',
      name: 'completely satisfied',
    },
    {
      id: '2',
      name: 'very satisfied',
    },
    {
      id: '3',
      name: 'satisfied',
    },
    {
      id: '4',
      name: 'rather dis-satisfied',
    },
    {
      id: '4',
      name: 'dis-satisfied',
    },
  ];
  // questionId
  // 1 for option
  // 2 for input
  // 3 for subquestion
  surveyFormArr = [
    {
      catId: 1,
      catName: 'Overall & loyalty questions',
      question: [
        {
          questionId: 1,
          questionType: 1,
          question:
            'Overall, how satisfied are you with Primetals Technologies?',
          options: [
            {
              id: '1',
              name: 'completely satisfied',
            },
            {
              id: '2',
              name: 'very satisfied',
            },
            {
              id: '3',
              name: 'satisfied',
            },
            {
              id: '4',
              name: 'rather dis-satisfied',
            },
            {
              id: '4',
              name: 'dis-satisfied',
            },
          ],
        },
        {
          questionId: 2,
          questionType: 2,
          question:
            'If you have the need, how likely is it that you would purchase from Primetals Technologies again?',
        },
        {
          questionId: 3,
          questionType: 3,
          question:
            'Specifically for this project, how satisfied are you with ...',
          options: [
            {
              id: '1',
              name: 'completely satisfied',
            },
            {
              id: '2',
              name: 'very satisfied',
            },
            {
              id: '3',
              name: 'satisfied',
            },
            {
              id: '4',
              name: 'rather dis-satisfied',
            },
            {
              id: '4',
              name: 'dis-satisfied',
            },
          ],
          subQuestion: [
            {
              subQuestionId: 1,
              subQuestion: '... the ease of access to your sales contacts?',
            },
            {
              subQuestionId: 2,
              subQuestion: '... the commitment of your sales contacts?',
            },
            {
              subQuestionId: 3,
              subQuestion: '... our understanding of your requirements?',
            },
          ],
        },
      ],
    },
    {
      catId: 2,
      catName: 'Sales service & support',
      question: [
        {
          questionId: 1,
          questionType: 1,
          question:
            'Overall, how satisfied are you with the Sales service & support provided by Primetals Technologies?',
          options: [
            {
              id: '1',
              name: 'completely satisfied',
            },
            {
              id: '2',
              name: 'very satisfied',
            },
            {
              id: '3',
              name: 'satisfied',
            },
            {
              id: '4',
              name: 'rather dis-satisfied',
            },
            {
              id: '4',
              name: 'dis-satisfied',
            },
          ],
        },
        {
          questionId: 2,
          questionType: 2,
          question:
            'Do you have any suggestions how Primetals Technologies could improve its Sales service & support?',
        },
      ],
    },
  ];

  zoom = 12;
  center: google.maps.LatLngLiteral = { lat: 28.6139, lng: 77.209 }; // New Delhi
  options: google.maps.MapOptions = {
    mapTypeId: 'roadmap',
    zoomControl: true,
    scrollwheel: true,
    disableDoubleClickZoom: true,
    maxZoom: 18,
    minZoom: 8,
  };

  // Marker Example
  markers = [
    {
      position: { lat: 28.6139, lng: 77.209 },
      label: { color: 'blue', text: 'Delhi' },
      title: 'New Delhi',
      options: { animation: google.maps.Animation.BOUNCE },
    },
    {
      position: { lat: 28.613, lng: 77.2099 },
      label: { color: 'green', text: 'Kathmandu' },
      title: 'Kathmandu',
      options: { animation: google.maps.Animation.BOUNCE },
    },
  ];
}
